var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{on:{"click":() => _setup.startGenerate()}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(
      "calendar:downloads.administrativeExcel.button",
      "Excel / XLSX administrative view"
    )))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }